export default {
  StopPropagation: {
    mounted() {
      this.el.addEventListener('click', e => {
        const event_name = this.el.getAttribute('phx-click');
        const attributes = {};
        for (const attr of this.el.attributes) {
          if (attr.name.startsWith('phx-value-')) {
            attributes[attr.name.replace('phx-value-', '')] = attr.value;
          }
        }
        e.preventDefault();
        e.stopPropagation();
        if (event_name !== null) this.pushEvent(event_name, attributes);
      });
    },
  },
};
